<template>
  <div>
    <loading :active.sync="loading"
             :can-cancel="false"
             :is-full-page="true"></loading>

    <div class="method-sheet">
      <div class="header">
        <h4><b> Select Payment Method </b></h4>
        <h6><b> Sale Total : {{ $utils.formatMoney(saleTotal - discount.total) }} </b></h6>
      </div>

      <div class="payment-method-btn">
        <button class="lyt-soft-btn" @click="processTransaction('Cash')">
          <font-awesome-icon icon="fa-solid fa-money-bills"/>
          Cash
        </button>
      </div>

      <div class="payment-method-btn">
        <button class="lyt-soft-btn" @click="processTransaction('Card')">
          <font-awesome-icon icon="fa-solid fa-credit-card"/>
          Card
        </button>
      </div>

      <div class="payment-method-btn" v-if="customer">
        <button class="lyt-soft-btn" @click="processTransaction('AccountSale')">
          <font-awesome-icon icon="fa-solid fa-address-card"/>
          Account
        </button>
      </div>

      <div class="payment-method-btn" v-if="!saleDetails.refund">
        <button class="lyt-soft-btn" @click="kazangPayment">
          <img height="25px" src="@/assets/img/Kazang.png" alt="Kazang">
          Kazang
        </button>
      </div>

      <div class="payment-method-btn" v-if="lodgeIntegrated && !saleDetails.refund">
        <button class="lyt-soft-btn" @click="roomPayment">
          <font-awesome-icon icon="fa-solid fa-bed" />
          Room
        </button>
      </div>

<!--      <div class="payment-method-btn" v-if="!saleDetails.refund">-->
<!--        <button class="lyt-soft-btn" @click="spennPayment">-->
<!--          <img height="35px" src="@/assets/img/SpennLogo.png" alt="Spenn">-->
<!--          Spenn-->
<!--        </button>-->
<!--      </div>-->

      <div class="payment-method-btn" v-if="isValidString(loyaltyDetails.barcode)">
        <button class="lyt-soft-btn" @click="processTransaction('Loyalty Program')">
          <font-awesome-icon icon="heart-circle-check" style="height: 20px"/>
          Loyalty
        </button>
      </div>

      <div class="payment-method-btn">
        <button class="lyt-soft-btn" @click="goToSplitScreen">
          <font-awesome-icon icon="fa-solid fa-arrows-split-up-and-left"/>
          Split
        </button>
      </div>

      <div class="payment-method-btn" v-for="method in paymentMethods">
        <ForeignCurrency :row-data="method" v-if="!method.IsBaseCurrency" @click="processTransaction(method.name)"/>
        <button class="lyt-soft-btn" @click="processTransaction(method.name)" v-else>
          {{ method.name }} ({{ method.CurrencySymbol }})
        </button>


      </div>
    </div>
  </div>
</template>

<script>
import ForeignCurrency from "@/components/point-of-sale/sales/payment/ForeignCurrency";
import LodgingIntegration from "@/services/lodgingIntegration";

export default {
  name: "PaymentMethods",
  components: {ForeignCurrency},
  props: {
    setSwipe: {type: Function, required: true}
  },
  computed: {
    saleDetails() {
      return this.$store.getters.getSaleDetails
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },
    customer() {
      return this.$store.getters.getCustomer;
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal + this.$store.getters.getTipAmount
    },
    deviceSettings() {
      return this.$store.getters.getDeviceSettings;
    },
    discount() {
      return this.$store.getters.getSaleDiscount;
    },
    paymentMethods() {
      return this.$store.getters.getPaymentMethods
          .filter(method => method.active);
    }
  },
  data() {
    return {
      loading: false,
      lodgeIntegrated: false
    }
  },
  async mounted() {
    this.lodgeIntegrated = await LodgingIntegration.isLodgeIntegrated();
  },
  methods: {
    createLayBySales(){
      return this.$router.push({ name : `lay-by-payment` });
    },
    isValidString(string){
      return isValidString(string);
    },
    processTransaction(type) {
      this.setSwipe();
      let obj = this.saleDetails;
      obj.type = type;
      this.openCashDrawer(); // Call openCashDrawer method here
      return this.$store.dispatch("processTransaction", obj)
          .then((res) => {
            return res;
          }).finally(() => {
            this.setSwipe();
          });
    },
    async openCashDrawer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `OpenDrwer`);
      let isAndroid = androidMode;
      if (!isAllowed || isAndroid) return;
      return this.$store.dispatch(`openCashDrawer`)
    },

    goToSplitScreen() {
      let obj = this.saleDetails;
      obj.type = 'Split';
      this.$store.commit('setSaleDetails', obj);
      return this.$router.push({name: 'split-payment'})
    },

    kazangPayment() {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          return this.$store.dispatch('firstKazangPaymentStep', input)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },

    async roomPayment() {
      this.setSwipe();

      // Set saleDetails with the correct sale total before initiating room payment
      const current = this.saleDetails || {};
      const updated = {
        ...current,
        refund: false,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: 0,
        change: 0
      };
      this.$store.commit('setSaleDetails', updated);

      // Emit event to show room selection modal
      this.$emit('show-room-selection');
    },

    confirmKazangPayment(firstKazangStepResponse) {
      if (firstKazangStepResponse === "processed") {
        return firstKazangStepResponse;
      }
      return Swal.fire({
        title: 'Confirm Kazang Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondKazangStep', firstKazangStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },

    spennPayment() {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'tel',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          return this.$store.dispatch('firstSpennPaymentStep', input)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                else return res;
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.confirmSpennPayment(result.value)
        }
      })
    },

    confirmSpennPayment(firstSpennStepResponse) {
      if (firstSpennStepResponse === "processed") {
        return firstSpennStepResponse;
      }
      return Swal.fire({
        title: 'Confirm Spenn Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondSpennStep', firstSpennStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return result.value;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.method-sheet {
  padding: 15px;
}

h4, h6 {
  display: flex;
  justify-content: center;
}

button {
  color: white;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  border-radius: 8px;
  height: 90%;
  width: 75%;
  max-width: 600px;
}

.payment-method-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
  height: 60px;
}

.header {
  position: sticky;
  top: 0;
  background: var(--card-bg);
  color: var(--text-primary);
  z-index: 1;
  padding: 10px;
}
</style>
